import { useAuth0 } from '@auth0/auth0-react'

import { SimpleProductDetailsFragment } from '../../../graphql/magento'
import { isItemPriceZero } from '../../../utils/priceTools'
import { useUserAccessPolicy } from '../../auth/user-access-policy'
import { useTestKitProducts } from './useTestKitProducts'

export const useTestKitDelayedBilling = (
  selectedVariant: SimpleProductDetailsFragment | null | undefined,
) => {
  const { isAuthenticated } = useAuth0()
  const { canPurchaseTestKits } = useUserAccessPolicy()
  const { isTestKitSku } = useTestKitProducts()

  const isTestKit = isTestKitSku(selectedVariant?.sku || '')
  const isCurrentPriceZero = isItemPriceZero(selectedVariant)
  return canPurchaseTestKits && isTestKit && isCurrentPriceZero && isAuthenticated
}
